import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Button';
import { Dialog } from 'src/components/Dialog';
import { Icon } from 'src/components/Icon';
import { Stack } from 'src/components/Stack';
import { useOptionalSession } from 'src/contexts/SessionContext';

import { usePosContext } from '../PosContext';

interface WelcomeDialogProps {
  open: boolean;
  onFindAccount: () => void;
  onContinueAsGuest: () => void;
}

export function WelcomeDialog({
  open,
  onFindAccount,
  onContinueAsGuest,
}: WelcomeDialogProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pointOfSale.welcome',
  });

  const { posType } = usePosContext();

  const { session, user, platformSettings } = useOptionalSession();

  return (
    <Dialog
      open={open}
      title={t('title', { brand: session?.brand })}
      maxWidth="sm"
      fullWidth
    >
      <Stack spacing={4} alignItems="center">
        <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
          <Button
            variant="contained"
            size="large"
            onClick={onFindAccount}
            startIcon={<Icon icon={icon({ name: 'user', style: 'regular' })} />}
            sx={{ flex: 1 }}
          >
            {user?.isTrainer ? t('searchAccount') : t('findMyAccount')}
          </Button>

          {posType !== 'kiosk' ||
          (posType === 'kiosk' && platformSettings?.enableGuestCheckout) ? (
            <Button
              variant="outlined"
              size="large"
              onClick={onContinueAsGuest}
              startIcon={
                <Icon icon={icon({ name: 'user-plus', style: 'regular' })} />
              }
              sx={{ flex: 1 }}
            >
              {t('continueAsGuest')}
            </Button>
          ) : null}
        </Stack>
      </Stack>
    </Dialog>
  );
}
